<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BypCv5/CoverDesign.jpg?1685327669173" alt="This image is the cover for the book Kissing Lessons, Before… and After"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kissing Lessons, Before… and After
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Before… and After Story</i></b></p><p>A kiss is just a kiss. It doesn’t have to mean anything. Does it?</p> <p>At seventeen, Merry’s never been kissed. Since he doesn’t want to disappoint his prom date, he asks his more experienced best friend, Boone, for some pointers. Surprisingly, Boone agrees to give him a hands-on lesson.</p> <p>But they have no idea what they’re getting into.</p> <p>They explore hundreds of ways to make out, but somehow it isn’t enough. A week later, they’re back together for another session. This time things go further than either of them planned, and their relationship becomes awkward and uncomfortable.</p> <p>Have they learned enough to salvage their friendship <em>and</em> help it evolve? Their lessons have come to an end. They can either part ways forever… or share a true love’s kiss.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Laine
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0491eea4